<template>
  <div id="Rating" style="font-size:11px">
    <div v-show="ownerEmail != responderEmail">
      <table v-show="ratedStars == 0">
        <tr>
          <td>Rate this response:</td>
          <td>
            <star-rating @rating-selected="setRating" :star-size="16"></star-rating>
          </td>
        </tr>
      </table>
    </div>

    <div v-show="ratedStars != 0">
      <table>
        <tr>
          <td>Rated:</td>
          <td>
            <!-- <star-rating :rating="thread.reviews[0].rate" :read-only="true" :star-size="16"></star-rating> -->
            <star-rating :rating="ratedStars" :read-only="true" :show-rating="false" :star-size="16"></star-rating>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Rating",

  data() {
    return {
      //reviewsCount: 0,
      ratedStars: 0,
    };
  },

  mounted() {
    if (this.thread.reviews.length > 0) {
      this.ratedStars = this.thread.reviews[0].rate;
    }
  },

  props: {
    thread: {
      reviews: {
        type: Array,
      },
    }, // the response owner is want to rate
    ownerEmail: String, // owner of the ticket
    responderEmail: String, // agent or other user who responded to the ticket
  },

  methods: {
    setRating(rating) {
      /* start */
      this.$swal
        .fire({
          title: "Please confirm your rating?",
          text: `You are about to rate this response ${rating} star(s).`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, do it.",
        })
        .then((result) => {
          if (result.value) {
            /* start actural action */
            let loading = this.$loading.show();
            let formData = new FormData();
            formData.append("email", this.ownerEmail);
            formData.append("uuid", this.thread.uuid);
            formData.append("rate", rating);

            axios.post("/rate", formData).then((res) => {
              //console.log(res.data);
              if (res.data.status == "success") {
                this.ratedStars = res.data.newReview.rate;
                this.$swal("", res.data.message, "success");
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
      /* end */
    },
  },
};
</script>

<style>
</style>